<!-- 0706022393 -->
<template>
	<div class="d-flex flex-column justify-content-center" :style="{ height: inset_height}">
		<div class="d-flex justify-content-center">	
			<div class="w-35 shadow p-4 rounded">     
				<h2 v-if="! inset" class="mb-5 text-success"> Vidduka | Reset password</h2>           			
				<ul v-if="confirmation_code_error.length" class="text-center list-unstyled">
					<li v-for="error in confirmation_code_error" :key="error">
						<small class="text-danger">{{ error }}</small>
					</li>
				</ul>
	
				<ul v-if="confirmation_code_info.length" class="text-center list-unstyled">
					<li v-for="error in confirmation_code_info" :key="error" class="text-info">
						<small>{{ error }}</small>
					</li>
				</ul>
                <div v-if="! confirmation_sent">
                    <div class="form-group">
                        <label v-if="! inset" for="phone">Phone Number</label>
                        <input type="text" class="form-control"
                                id="phone" placeholder="phone number" 
                                v-model="phone_number">
                        <span class="p-2">
                            <small>Enter the phone number you registered to vidduka</small>
                        </span>                                                
                    </div>	
                    <!-- /.submit button -->
                    <div class="d-flex justify-content-end" @keyup.enter="sendConfirmationCode()">
                        <button class="btn btn-success btn-block btn-flat"
                            @click="sendConfirmationCode()">
                            Send confirmation code
                        </button>
                    </div>                    
                </div>					
                <div v-if="confirmation_sent">            
                    <div class="form-group">
                        <label v-if="! inset" for="password">Confirmation code</label>
                        <input type="text" class="form-control"
                                id="confirmation_code" placeholder="confirmation code"
                                v-model="confirmation_code">
                        <br>
                    </div>
                    <div class="form-group">
                        <label v-if="! inset" for="password">New password</label>
                        <input type="password" class="form-control"
                                id="confirmation_code" placeholder="***********"
                                v-model="password">
                        <br>
                    </div>
                    <div class="form-group">
                        <label v-if="! inset" for="password">confirm password</label>
                        <input type="password" class="form-control"
                                id="password_confirmation" placeholder="**********"
                                v-model="password_confirmation">
                        <br>
                    </div>
                    <!-- /.submit button -->
                    <div class="d-flex justify-content-end">
                    <button class="btn btn-success btn-block btn-flat"
                        @click="resetPassword()">
                        Reset password
                    </button>
                </div> 
                </div>								
			</div>
		</div>
	</div>   
</template>
<script>
export default {
	name: 'login',
	props:{
		inset:{
			type: Boolean,
			default: false
		},
		inset_height:{
			type:String,
			default: "100vh"
		}
	},
	data() {
	return {     
        confirmation_sent: false,
		//form data   			        	
		phone_number: null,
		confirmation_code: null,
        password:null,
        password_confirmation:null,
		//view state
		confirmation_code_error: [],
		confirmation_code_info: [],
		//logged in user
		logged_in_user:null,
		logged_in_user_location_id:null
	}
	},	
	methods: {	
	//send confirmation code
	sendConfirmationCode: function () { 
		//clear errors and info   		
		this.confirmation_code_info = []
		this.confirmation_code_error = []
		//get token from network
		this.confirmation_code_info.push("sending reset code...")		
		this.$http({
			method: 'post',
			url: this.$API_BASE_URL + '/HJYBCFRB/user/password/reset-request',
			data: {
				phone: this.phone_number,				
			}
			}).then(() => {				
				//clear errors and info
				this.confirmation_code_info = []
				this.confirmation_code_error = []  
				//update view state
                this.confirmation_sent = true

			}).catch(() => {
				//clear errors and info
				this.confirmation_code_info = []
				this.confirmation_code_error = []
				//if error has no response
                this.confirmation_code_error.push("Phone number invalid or not registered to vidduka.")				
			})
	},
	//reset password
	resetPassword: function () { 
        // check if passwords match
        if (this.password !== this.password_confirmation){
            this.confirmation_code_error.push("Password confimation does not match password")
            return
        }
		//clear errors and info   		
		this.confirmation_code_info = []
		this.confirmation_code_error = []
		//get token from network
		this.confirmation_code_info.push("requesting password reset...")		
		this.$http({
			method: 'post',
			url: this.$API_BASE_URL + '/HJYBCFRB/user/password/reset',
			data: {
				code: this.confirmation_code,				
                newPassword:this.password
			}
			}).then(() => {				
				//clear errors and info
				this.confirmation_code_info = []
				this.confirmation_code_error = []  
				//update view state
                this.$router.push('/login')

			}).catch(() => {
				//clear errors and info
				this.confirmation_code_info = []
				this.confirmation_code_error = []
				//if error has no response
                this.confirmation_code_error.push("Confirmation code entered is invalid")				
			})
	},
	}
}
</script>